import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { PRODUCT_CREATE_RESET } from "../../Redux/Constants/ProductConstants";
import { createProduct } from "./../../Redux/Actions/ProductActions";
import Toast from "../LoadingError/Toast";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";
import {listCategories} from "../../Redux/Actions/CategoryActions";
import {PickerOverlay} from "filestack-react";



const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};
const AddProductMain = () => {

  const [isPicker, setIsPicker] = useState(false);



  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [image, setImage] = useState("");
  const [countInStock, setCountInStock] = useState(0);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");

  const dispatch = useDispatch();

  const productCreate = useSelector((state) => state.productCreate);
  const { loading, error, product } = productCreate;

  const categoryList = useSelector((state) => state.categoryList);
    const { loading: loadingCategory, error: errorCategory, categories } = categoryList;

  useEffect(() => {
    dispatch(listCategories());

    if (product) {
      toast.success("Product Added", ToastObjects);
      dispatch({ type: PRODUCT_CREATE_RESET });
      setName("");
      setDescription("");
      setCountInStock(0);
      setImage("");
      setPrice(0);
    }
  }, [product, dispatch]);

  const submitHandler = (e) => {
    e.preventDefault();
    if(category){
      if(image){
        dispatch(createProduct(name,category, price, description, image.filesUploaded[0].url,countInStock));
      }
    else{
        toast.error("Image is required", ToastObjects);
        }
    }
    else{
        toast.error("Please Select Category", ToastObjects);
    }
  };

  return (
    <>
      <Toast />
      <section className="content-main" style={{ maxWidth: "1200px" }}>
        <form onSubmit={submitHandler}>
          <div className="content-header">
            <Link to="/products" className="btn btn-danger text-white">
              Go to products
            </Link>
            <h2 className="content-title">Add product</h2>
            <div>
              <button type="submit" className="btn btn-primary">
                Publish now
              </button>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-xl-8 col-lg-8">
              <div className="card mb-4 shadow-sm">
                <div className="card-body">
                  {error && <Message variant="alert-danger">{error}</Message>}
                  {loading && <Loading />}
                  <div className="mb-4">
                    <label htmlFor="product_title" className="form-label">
                      Product title
                    </label>
                    <input
                      type="text"
                      placeholder="Type here"
                      className="form-control"
                      id="product_title"
                      required
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value)

                      }}
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="product_title" className="form-label">
                      Product Category
                    </label>
                    <select
                        className="form-control"
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value)
                          console.log(e.target.value)
                        }}
                        >
                        <option value="">Select Category</option>
                        {categories.map((category) => (
                            <option key={category._id} value={category._id}>
                            {category.name}
                            </option>
                        ))}
                    </select>

                  </div>

                  <div className="mb-4">
                    <label htmlFor="product_price" className="form-label">
                      Price
                    </label>
                    <input
                      type="number"
                      placeholder="Type here"
                      className="form-control"
                      id="product_price"
                      required
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="product_price" className="form-label">
                      Count In Stock
                    </label>
                    <input
                      type="number"
                      placeholder="Type here"
                      className="form-control"
                      id="product_price"

                      value={countInStock}
                      onChange={(e) => setCountInStock(e.target.value)}
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label">Description</label>
                    <textarea
                      placeholder="Type here"
                      className="form-control"
                      rows="7"

                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                  </div>
                  {/*<div className="mb-4">*/}
                  {/*  <label className="form-label">Images (Example : https://example.com/hamsa.png)</label>*/}
                  {/*  <input*/}
                  {/*    className="form-control"*/}
                  {/*    type="text"*/}
                  {/*    placeholder="Enter Image URL"*/}
                  {/*    value={image}*/}
                  {/*    required*/}
                  {/*    onChange={(e) => setImage(e.target.value)}*/}
                  {/*  />*/}
                  {/*  /!*<input className="form-control mt-3" type="file" />*!/*/}
                  {/*</div>*/}

                  {/*------------------IMAGE PART---------------------*/}

                  <button
                      onClick={() => (isPicker ? setIsPicker(false) : setIsPicker(true))}
                      type="button"
                      className="btn btn-info mt-2 mb-2"
                  >
                    Choose Image
                  </button>

                  <div className="mb-4">
                  {image && (
                      <img
                          src={image && image.filesUploaded[0].url}
                          alt="imageUploded"
                          className="img-fluid"
                      />
                  ) }
                  </div>


                  {/* input title */}

                  {/* submit button */}

                  {/* Filestack */}
                  <div className="mt-4 relative">
                    {isPicker && (
                        <PickerOverlay
                            apikey={"ASekhCKTSyjCJ7AWkN2Wwz"}
                            onSuccess={(res) => {
                              setImage(res);
                              setIsPicker(false);
                            }}
                            onError={(res) => alert(res)}
                            pickerOptions={{
                              maxFiles: 1,
                              accept: ["image/*"],
                              errorsTimeout: 2000,
                              maxSize: 1 * 1000 * 1000,
                            }}
                        />
                    )}
                  </div>



                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </>
  );
};

export default AddProductMain;
